import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ValueMap } from "../../filters/types";
import { ALL_ADS_TYPES } from "../constants";
import type { AdsType } from "../types";
import { ALL_SOCIAL_SUBCATEGORIES, type SocialSubcategoryId } from "../utils/getPlatformName";

interface IAdsAlertsFilterState {
    isDefaultAdsTypesSelected: boolean;
    selectedAdsTypes: ValueMap<AdsType>;
    selectedSocialSubcategories: Set<SocialSubcategoryId>;
}

interface IAdsAlertsFilterStore extends IAdsAlertsFilterState {
    reset: () => void;
    setFilterSelection: (adsTypes: ValueMap<AdsType>, socialSubs: Set<SocialSubcategoryId>) => void;
}

const ALL_FILTER_ITEM_COUNT = ALL_ADS_TYPES.filter((t) => t !== "Social").length + ALL_SOCIAL_SUBCATEGORIES.length;

const isDefaultSelection = (adsTypes: ValueMap<AdsType>, socialSubs: Set<SocialSubcategoryId>): boolean => {
    const totalSelected = adsTypes.size + socialSubs.size;
    return totalSelected === ALL_FILTER_ITEM_COUNT || totalSelected === 0;
};

const initialState: IAdsAlertsFilterState = {
    isDefaultAdsTypesSelected: true,
    selectedAdsTypes: new Map(),
    selectedSocialSubcategories: new Set(),
};

export const useAdsAlertsFilterStore = create<IAdsAlertsFilterStore>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(initialState),
            setFilterSelection: (adsTypes, socialSubs) =>
                set({
                    selectedAdsTypes: adsTypes,
                    selectedSocialSubcategories: socialSubs,
                    isDefaultAdsTypesSelected: isDefaultSelection(adsTypes, socialSubs),
                }),
        }),
        { name: "AdsAlertsFilterStore" },
    ),
);
